import { RoleCode } from '@/common/utils/role.utils';

export type RoleEvent = 'Removed' | 'Changed' | 'Added';
export type EntityType = 'Organisation' | 'Project' | 'Site';

export enum RoleEventEnum {
  REMOVED = 'Removed',
  CHANGED = 'Changed',
  ADDED = 'Added',
}

export enum StatusEventEnum {
  CHANGED = 'StatusChanged',
}

export enum EntityTypeEnum {
  ORG = 'Organisation',
  PROJECT = 'Project',
  SITE = 'Site',
}

export interface PusherMessage {
  channel: string;
  event: string;
  data: RoleMessageData | StatusMessageData;
  timestamp: string;
}

export type RoleMessageData = {
  Id: string;
  OrgId: string;
  UserId: string;
  ActionedById: string;
  EntityId: string;
  EntityName: string;
  EntityType: EntityType;
  EventType: RoleEvent;
  RoleCode: RoleCode;
};

export type StatusMessageData = {
  Id: string;
  EventType: StatusEventEnum;
  OrgId: string;
  SiteId: string;
  ProjectId: string;
};
